/*
insert into i11rs (
  _key,
  _vsn,
  _ltt,
  _fst,
  _dmn,
  i11r_31r1f,
  _icn,
  _pfx,
  i11ra1100i,
  i11ra1200i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  1,
  1,
  1,
  1,
  1,
  1,
  '1',
  '時間帯区分1',
  7,
  9,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);

insert into i111s (
  _key,_vsn,_ltt,_fst,
  _dmn,i111_31r1f,
  i111i11r1k,
  _icn,
  _pfx,
  i111a1111i,i111a1112i,i111a1113i, 
  i111a1121i,i111a1122i,i111a1123i,
  i111a1211i,i111a1212i,i111a1213i,
  i111a1221i,i111a1222i,i111a1223i,
  i111a2111i,i111a2112i,i111a2113i,
  i111a2121i,i111a2122i,i111a2123i,
  i111a2211i,i111a2212i,i111a2213i,
  i111a2221i,i111a2222i,i111a2223i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  11,1,1,11,
  1,1,
  1,
  '1',
  '午前',
   9, 9, 9,  8, 8, 8,  9, 9, 9,  8, 8, 8,
  12,12,12, 11,11,11, 12,12,12, 11,11,11,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);

insert into i111s (
  _key,_vsn,_ltt,_fst,
  _dmn,i111_31r1f,
  i111i11r1k,
  _icn,
  _pfx,
  i111a1111i,i111a1112i,i111a1113i, 
  i111a1121i,i111a1122i,i111a1123i,
  i111a1211i,i111a1212i,i111a1213i,
  i111a1221i,i111a1222i,i111a1223i,
  i111a2111i,i111a2112i,i111a2113i,
  i111a2121i,i111a2122i,i111a2123i,
  i111a2211i,i111a2212i,i111a2213i,
  i111a2221i,i111a2222i,i111a2223i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  12,1,1,12,
  1,1,
  1,
  '2',
  '午後1',
  12,12,12, 11,11,11, 12,12,12, 11,11,11,
  15,15,15, 14,14,14, 15,15,15, 14,14,14,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);

insert into i111s (
  _key,_vsn,_ltt,_fst,
  _dmn,i111_31r1f,
  i111i11r1k,
  _icn,
  _pfx,
  i111a1111i,i111a1112i,i111a1113i, 
  i111a1121i,i111a1122i,i111a1123i,
  i111a1211i,i111a1212i,i111a1213i,
  i111a1221i,i111a1222i,i111a1223i,
  i111a2111i,i111a2112i,i111a2113i,
  i111a2121i,i111a2122i,i111a2123i,
  i111a2211i,i111a2212i,i111a2213i,
  i111a2221i,i111a2222i,i111a2223i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  13,1,1,13,
  1,1,
  1,
  '3',
  '午後2',
  15,15,15, 14,14,14, 15,15,15, 14,14,14,
  18,18,18, 17,17,17, 18,18,18, 17,17,17,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);

insert into i111s (
  _key,_vsn,_ltt,_fst,
  _dmn,i111_31r1f,
  i111i11r1k,
  _icn,
  _pfx,
  i111a1111i,i111a1112i,i111a1113i, 
  i111a1121i,i111a1122i,i111a1123i,
  i111a1211i,i111a1212i,i111a1213i,
  i111a1221i,i111a1222i,i111a1223i,
  i111a2111i,i111a2112i,i111a2113i,
  i111a2121i,i111a2122i,i111a2123i,
  i111a2211i,i111a2212i,i111a2213i,
  i111a2221i,i111a2222i,i111a2223i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  14,1,1,14,
  1,1,
  1,
  '4',
  '夕方',
  18,18,18, 17,17,17, 18,18,18, 17,17,17,
  21,21,21, 20,20,20, 20,20,20, 19,19,19,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);


insert into i11rs (
  _key,_vsn,_ltt,_fst,
  _dmn,i11r_31r1f,
  _icn,
  _pfx,
  i11ra1100i,
  i11ra1200i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  2,1,1,2,
  1,1,
  '2',
  '時間帯区分2',
  7,
  9,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);

insert into i111s (
  _key,_vsn,_ltt,_fst,
  _dmn,i111_31r1f,
  i111i11r1k,
  _icn,
  _pfx,
  i111a1111i,i111a1112i,i111a1113i, 
  i111a1121i,i111a1122i,i111a1123i,
  i111a1211i,i111a1212i,i111a1213i,
  i111a1221i,i111a1222i,i111a1223i,
  i111a2111i,i111a2112i,i111a2113i,
  i111a2121i,i111a2122i,i111a2123i,
  i111a2211i,i111a2212i,i111a2213i,
  i111a2221i,i111a2222i,i111a2223i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  21,1,1,21,
  1,1,
  2,
  '1',
  '午前1',
   8, 8, 8,  7, 7, 7,  8, 8, 8,  7, 7, 7,
  10,10,10,  9, 9, 9, 10,10,10,  9, 9, 9,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);

insert into i111s (
  _key,_vsn,_ltt,_fst,
  _dmn,i111_31r1f,
  i111i11r1k,
  _icn,
  _pfx,
  i111a1111i,i111a1112i,i111a1113i, 
  i111a1121i,i111a1122i,i111a1123i,
  i111a1211i,i111a1212i,i111a1213i,
  i111a1221i,i111a1222i,i111a1223i,
  i111a2111i,i111a2112i,i111a2113i,
  i111a2121i,i111a2122i,i111a2123i,
  i111a2211i,i111a2212i,i111a2213i,
  i111a2221i,i111a2222i,i111a2223i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  22,1,1,22,
  1,1,
  2,
  '2',
  '午前2',
  10,10,10,  9, 9, 9, 10,10,10,  9, 9, 9,
  12,12,12, 11,11,11, 12,12,12, 11,11,11,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);

insert into i111s (
  _key,_vsn,_ltt,_fst,
  _dmn,i111_31r1f,
  i111i11r1k,
  _icn,
  _pfx,
  i111a1111i,i111a1112i,i111a1113i, 
  i111a1121i,i111a1122i,i111a1123i,
  i111a1211i,i111a1212i,i111a1213i,
  i111a1221i,i111a1222i,i111a1223i,
  i111a2111i,i111a2112i,i111a2113i,
  i111a2121i,i111a2122i,i111a2123i,
  i111a2211i,i111a2212i,i111a2213i,
  i111a2221i,i111a2222i,i111a2223i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  23,1,1,23,
  1,1,
  2,
  '3',
  '午後1',
  12,12,12, 11,11,11, 12,12,12, 11,11,11,
  14,14,14, 13,13,13, 14,14,14, 13,13,13,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);

insert into i111s (
  _key,_vsn,_ltt,_fst,
  _dmn,i111_31r1f,
  i111i11r1k,
  _icn,
  _pfx,
  i111a1111i,i111a1112i,i111a1113i, 
  i111a1121i,i111a1122i,i111a1123i,
  i111a1211i,i111a1212i,i111a1213i,
  i111a1221i,i111a1222i,i111a1223i,
  i111a2111i,i111a2112i,i111a2113i,
  i111a2121i,i111a2122i,i111a2123i,
  i111a2211i,i111a2212i,i111a2213i,
  i111a2221i,i111a2222i,i111a2223i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  24,1,1,24,
  1,1,
  2,
  '4',
  '午後2',
  14,14,14, 13,13,13, 14,14,14, 13,13,13,
  16,16,16, 15,15,15, 16,16,16, 15,15,15,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);

insert into i111s (
  _key,_vsn,_ltt,_fst,
  _dmn,i111_31r1f,
  i111i11r1k,
  _icn,
  _pfx,
  i111a1111i,i111a1112i,i111a1113i, 
  i111a1121i,i111a1122i,i111a1123i,
  i111a1211i,i111a1212i,i111a1213i,
  i111a1221i,i111a1222i,i111a1223i,
  i111a2111i,i111a2112i,i111a2113i,
  i111a2121i,i111a2122i,i111a2123i,
  i111a2211i,i111a2212i,i111a2213i,
  i111a2221i,i111a2222i,i111a2223i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  25,1,1,25,
  1,1,
  2,
  '5',
  '夕方1',
  16,16,16, 15,15,15, 16,16,16, 15,15,15,
  18,18,18, 17,17,17, 18,18,18, 17,17,17,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);

insert into i111s (
  _key,_vsn,_ltt,_fst,
  _dmn,i111_31r1f,
  i111i11r1k,
  _icn,
  _pfx,
  i111a1111i,i111a1112i,i111a1113i, 
  i111a1121i,i111a1122i,i111a1123i,
  i111a1211i,i111a1212i,i111a1213i,
  i111a1221i,i111a1222i,i111a1223i,
  i111a2111i,i111a2112i,i111a2113i,
  i111a2121i,i111a2122i,i111a2123i,
  i111a2211i,i111a2212i,i111a2213i,
  i111a2221i,i111a2222i,i111a2223i,
  "createdAt",
  "updatedAt",
  _dlt
) VALUES (
  26,1,1,26,
  1,1,
  2,
  '6',
  '夕方2',
  18,18,18, 17,17,17, 18,18,18, 17,17,17,
  20,20,20, 19,19,19, 20,20,20, 19,19,19,
  '2000-01-01 00:00:00',
  '2000-01-01 00:00:00',
  -1
);

*/

import * as _hmFTH from './_hmFTH';
import * as _ht from './_ht';

export const grtQryLoadI11rLsAsync = (uz: _ht.uz, pz: {
  _31r_fst: _ht.n,
  i1zrd3100s?: _ht.s,
  yearMth?: _ht.s,
  i1zrs1100iMnm?: _ht.n,
  i10rt1100i?: _ht.n, // 単体部屋のみ
  lwrType?: _ht.n,
}) => {
//  const _gUserz = useGblz('user');
//  let _cdn = _hmFTH.vdd(uz) + ` AND i11r_31r1f=${_gUserz.crt._31rz._fst}`;
  let _cdnI1z1 = _hmFTH.vdd(uz, { bVsn: false });
//  _cdnI1z1 += ` AND i1z1i10r1f = {i10r_fst}`;
  _cdnI1z1 += ` AND (
    i1z1i10r1f = {i10r_fst}
    OR i1z1i10r1f IN (
      SELECT
        _fst
      FROM
        i10rs
      WHERE
        ${_hmFTH.vdd(uz)}
        AND _key IN (
          SELECT
            i102i10r1k
          FROM
            i102s
          WHERE
            ${_hmFTH.vdd(uz)}
            AND i102i10r1f = {i10r_fst}
        )
    )
  )
  `; // 単体部屋＋単体部屋が含まれる複合部屋
  _cdnI1z1 += ` AND (
        (i1z1c4100i = 111 AND i1z1a1100i<{i111a2111i} AND i1z1a1200i>{i111a1111i})
    OR (i1z1c4100i = 112 AND i1z1a1100i<{i111a2112i} AND i1z1a1200i>{i111a1112i})
    OR (i1z1c4100i = 113 AND i1z1a1100i<{i111a2113i} AND i1z1a1200i>{i111a1113i})
    OR (i1z1c4100i = 121 AND i1z1a1100i<{i111a2121i} AND i1z1a1200i>{i111a1121i})
    OR (i1z1c4100i = 122 AND i1z1a1100i<{i111a2122i} AND i1z1a1200i>{i111a1122i})
    OR (i1z1c4100i = 123 AND i1z1a1100i<{i111a2123i} AND i1z1a1200i>{i111a1123i})
    OR (i1z1c4100i = 211 AND i1z1a1100i<{i111a2211i} AND i1z1a1200i>{i111a1211i})
    OR (i1z1c4100i = 212 AND i1z1a1100i<{i111a2212i} AND i1z1a1200i>{i111a1212i})
    OR (i1z1c4100i = 213 AND i1z1a1100i<{i111a2213i} AND i1z1a1200i>{i111a1213i})
    OR (i1z1c4100i = 221 AND i1z1a1100i<{i111a2221i} AND i1z1a1200i>{i111a1221i})
    OR (i1z1c4100i = 222 AND i1z1a1100i<{i111a2222i} AND i1z1a1200i>{i111a1222i})
    OR (i1z1c4100i = 223 AND i1z1a1100i<{i111a2223i} AND i1z1a1200i>{i111a1223i})
  )`;
  const _cdnI1zrd3100s = 
    (pz.i1zrd3100s) ?
      ` AND i1zrd3100s = '${pz.i1zrd3100s}'`
    : (pz.yearMth) ?
      ` AND i1zrd3100s LIKE '${pz.yearMth}%'`
    : '';
  _cdnI1z1 += ` AND i1z1i1zr1k IN (
    SELECT 
      _key 
    FROM 
      i1zrs 
    WHERE 
      ${_hmFTH.vdd(uz)} 
      AND i1zr_31r1f = ${pz._31r_fst} 
      AND i1zrs1100i >= ${pz.i1zrs1100iMnm ?? -1}
      ${_cdnI1zrd3100s}
  )`;

  return {
    tgt: 'i11rs',
    cdn: _hmFTH.vdd(uz) + ` AND i11r_31r1f=${pz._31r_fst}`,
    fld: '_fst as key, _pfx as pfx, *',
    lwrz: 
      pz?.lwrType == 1 ? // 実績集計表以外
      {
        i111s: {
          tgt: 'i111s',
          cdn: _hmFTH.vdd(uz, { bVsn: false }) + ` AND i111i11r1k = {i11r_key}`,
          rlcz: {
            i11r_key: 'i11rs._key',
          },
          tailz: {
            odr: '_icn',
          }
        },
        i10rs: {
          tgt: 'i10rs',
          cdn: _hmFTH.vdd(uz) + ` AND i10ri11r1f = {i11r_fst}` + (pz.i10rt1100i ? ` AND i10rt1100i = ${pz.i10rt1100i}` : ``),
          rlcz: {
            i11r_fst: 'i11rs._fst',
          },
          tailz: {
            odr: '_icn',
          },
          lwrz: {
            i111s: {
              tgt: 'i111s',
              cdn: _hmFTH.vdd(uz, { bVsn: false }) + ` AND i111i11r1k = {i11r_key}`,
              rlcz: {
                i11r_key: 'i11rs._key',
              },
              tailz: {
                odr: '_icn',
              },
              lwrz: {
                i1z1s: { // その他１時間を考慮し、開始・終了時刻で集計
                  tgt: 'i1z1s',
                  cdn: _cdnI1z1,
                  rlcz: {
                    i10r_fst: 'i10rs._fst',
                    i111a1111i: 'i111s.i111a1111i',
                    i111a1112i: 'i111s.i111a1112i',
                    i111a1113i: 'i111s.i111a1113i',
                    i111a1121i: 'i111s.i111a1121i',
                    i111a1122i: 'i111s.i111a1122i',
                    i111a1123i: 'i111s.i111a1123i',
                    i111a2111i: 'i111s.i111a2111i',
                    i111a2112i: 'i111s.i111a2112i',
                    i111a2113i: 'i111s.i111a2113i',
                    i111a2121i: 'i111s.i111a2121i',
                    i111a2122i: 'i111s.i111a2122i',
                    i111a2123i: 'i111s.i111a2123i',
                    i111a1211i: 'i111s.i111a1211i',
                    i111a1212i: 'i111s.i111a1212i',
                    i111a1213i: 'i111s.i111a1213i',
                    i111a1221i: 'i111s.i111a1221i',
                    i111a1222i: 'i111s.i111a1222i',
                    i111a1223i: 'i111s.i111a1223i',
                    i111a2211i: 'i111s.i111a2211i',
                    i111a2212i: 'i111s.i111a2212i',
                    i111a2213i: 'i111s.i111a2213i',
                    i111a2221i: 'i111s.i111a2221i',
                    i111a2222i: 'i111s.i111a2222i',
                    i111a2223i: 'i111s.i111a2223i',
                  },
                  lwrz: {
                    i1zrs: {
                      tgt: 'i1zrs',
                      cdn: _hmFTH.vdd(uz, { bVsn: false }) + ` AND _key = {i1z1i1zr1k}`,
                      rlcz: {
                        i1z1i1zr1k: 'i1z1s.i1z1i1zr1k',
                      },
                      lwrz: {
                        i18rs: {
                          tgt: 'i18rs',
                          cdn: _hmFTH.vdd(uz) + ` AND _fst = {i1zri18r1f}`,
                          rlcz: {
                            i1zri18r1f: 'i1zrs.i1zri18r1f',
                          },
                        }
                      }
                    },
                  }
                }
              }
            },
          }
        }
      }
      : pz?.lwrType == 2 ? // 実績集計表 団体種別別集計との整合性、その他１時間の扱いを考慮し、cldType == 1 とは別に集計
      {
        i111s: {
          tgt: 'i111s',
          cdn: _hmFTH.vdd(uz, { bVsn: false }) + ` AND i111i11r1k = {i11r_key}`,
          rlcz: {
            i11r_key: 'i11rs._key',
          },
          tailz: {
            odr: '_icn',
          }
        },
        i10rs: {
          tgt: 'i10rs',
          cdn: _hmFTH.vdd(uz) + ` AND i10ri11r1f = {i11r_fst}`,
          rlcz: {
            i11r_fst: 'i11rs._fst',
          },
          tailz: {
            odr: '_icn',
          },
          lwrz: {
            i1zrs: {
              tgt: 'i1zrs',
              cdn: _hmFTH.vdd(uz) + `
                AND i1zrd3100s LIKE '${pz.yearMth}%'
                AND i1zrs1100i >= ${pz.i1zrs1100iMnm ?? -1}
                AND _key IN (
                  SELECT
                    i1z1i1zr1k
                  FROM
                    i1z1s
                  WHERE
                    ${_hmFTH.vdd(uz)}
                    AND i1z1i10r1f = {i10r_fst}
              )`,
              rlcz: {
                i10r_fst: 'i10rs._fst',
              },
              lwrz: {
                i1z1s: { // その他１時間を考慮し、開始・終了時刻で集計しない
                  tgt: 'i1z1s',
                  cdn: _hmFTH.vdd(uz, { bVsn: false }) + `
                    AND i1z1i1zr1k = {i1zr_key}
                    AND i1z1i10r1f = {i10r_fst}
                  `, // i10r に紐づく i1z1 に限定
                  rlcz: {
                    i1zr_key: 'i1zrs._key',
                    i10r_fst: 'i10rs._fst',
                  },
                  lwrz: {
                    i111s: {
                      tgt: 'i111s',
                      cdn: _hmFTH.vdd(uz, { bVsn: false }) + `
                        AND i111i11r1k = {i11r_key}
                        AND _fst = {i111_fst}
                      `,
                      rlcz: {
                        i11r_key: 'i11rs._key',
                        i111_fst: 'i1z1s.i1z1i1111f',
                      },
                      tailz: {
                        odr: '_icn',
                      },
                    }
                  }
                }
              }

            },

          }
        }
      }
      : undefined,
  };
};

export const i11z = {
  i11r: { // 時間帯区分
    v0: {
      itlz: {
        i11r_31r1f: -1,
        i11ra1100i: 0,
        i11ra1200i: 0,
      },
      fldz: {
        i11r_31r1f: {
          pfx: '施設' 
        },
        i11ra1100i: {
          pfx: '夏時間開始月',
        },
        i11ra1200i: {
          pfx: '夏時間終了月',
        },
      },
    },
  },
  i111: { // 時間帯
    v0: {
      itlz: {
        i111_31r1f: -1,
        i111i11r1k: -1,
        i111a1111i: 0,
        i111a1211i: 0,
        i111a2111i: 0,
        i111a2211i: 0,
        i111a1112i: 0,
        i111a1212i: 0,
        i111a2112i: 0,
        i111a2212i: 0,
        i111a1113i: 0,
        i111a1213i: 0,
        i111a2113i: 0,
        i111a2213i: 0,
        i111a1121i: 0,
        i111a1221i: 0,
        i111a2121i: 0,
        i111a2221i: 0,
        i111a1122i: 0,
        i111a1222i: 0,
        i111a2122i: 0,
        i111a2222i: 0,
        i111a1123i: 0,
        i111a1223i: 0,
        i111a2123i: 0,
        i111a2223i: 0,
      },
      fldz: {
        i111_31r1f: {
          pfx: '施設' 
        },
        i111i11r1k: {
          pfx: '時間帯区分',
        },
        i111a1111i: {
          pfx: '開始時刻／１種／通常／平日',
        },
        i111a1211i: {
          pfx: '開始時刻／２種／通常／平日',
        },
        i111a2111i: {
          pfx: '終了時刻／１種／通常／平日',
        },
        i111a2211i: {
          pfx: '終了時刻／２種／通常／平日',
        },
        i111a1112i: {
          pfx: '開始時刻／１種／通常／土曜',
        },
        i111a1212i: {
          pfx: '開始時刻／２種／通常／土曜',
        },
        i111a2112i: {
          pfx: '終了時刻／１種／通常／土曜',
        },
        i111a2212i: {
          pfx: '終了時刻／２種／通常／土曜',
        },
        i111a1113i: {
          pfx: '開始時刻／１種／通常／日祝',
        },
        i111a1213i: {
          pfx: '開始時刻／２種／通常／日祝',
        },
        i111a2113i: {
          pfx: '終了時刻／１種／通常／日祝',
        },
        i111a2213i: {
          pfx: '終了時刻／２種／通常／日祝',
        },
        i111a1121i: {
          pfx: '開始時刻／１種／夏時間／平日',
        },
        i111a1221i: {
          pfx: '開始時刻／２種／夏時間／平日',
        },
        i111a2121i: {
          pfx: '終了時刻／１種／夏時間／平日',
        },
        i111a2221i: {
          pfx: '終了時刻／２種／夏時間／平日',
        },
        i111a1122i: {
          pfx: '開始時刻／１種／夏時間／土曜',
        },
        i111a1222i: {
          pfx: '開始時刻／２種／夏時間／土曜',
        },
        i111a2122i: {
          pfx: '終了時刻／１種／夏時間／土曜',
        },
        i111a2222i: {
          pfx: '終了時刻／２種／夏時間／土曜',
        },
        i111a1123i: {
          pfx: '開始時刻／１種／夏時間／日祝',
        },
        i111a1223i: {
          pfx: '開始時刻／２種／夏時間／日祝',
        },
        i111a2123i: {
          pfx: '終了時刻／１種／夏時間／日祝',
        },
        i111a2223i: {
          pfx: '終了時刻／２種／夏時間／日祝',
        },
      },
    },
  },
};
